// ============================================================
// Pay Rocky — Entry Point
// ============================================================

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { hasStoredAdminSession, unregisterPushServiceWorker } from './utils/push';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (process.env.NODE_ENV === 'production' && !hasStoredAdminSession()) {
  unregisterPushServiceWorker().catch(() => {});
}
